import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuardService implements CanActivate {

  constructor(private _router: Router) { }
  visaUserType: string = "";
  canActivate() {

    if (localStorage.getItem('adminUser')) {
      // logged in so return true
      // alert('admin');
      this.visaUserType = "adminUser";
      return true;
    }

    // not logged in so redirect to login page
    this._router.navigate(['/']);
    return false;
  }
}
